// trade-space.js – interactive trade listings with search, lazy load, detail modal, and edit/delete

async function jsonFetch(url, options = {}) {
  const token = localStorage.getItem('lnf_token');
  const baseHeaders = { 'Content-Type': 'application/json' };
  if (token) baseHeaders.Authorization = 'Bearer ' + token;
  const opts = {
    headers: { ...baseHeaders, ...(options.headers || {}) },
    ...options
  };
  const res = await fetch(url, opts);
  if (!res.ok) {
    const text = await res.text();
    let message = text || `Request failed: ${res.status}`;
    try {
      const parsed = JSON.parse(text);
      if (parsed && typeof parsed === 'object') {
        message = parsed.error || parsed.message || message;
      }
    } catch (_err) {
      // fall back to raw text
    }
    throw new Error(message);
  }
  return res.status === 204 ? null : res.json();
}

document.addEventListener('DOMContentLoaded', () => {
  const listEl = document.getElementById('tradeList');
  const listStatus = document.getElementById('tradeListStatus');
  const filterCategory = document.getElementById('filterCategory');
  const filterRegion = document.getElementById('filterRegion');
  const loadMoreBtn = document.getElementById('loadMoreTrades');

  // Form + modal
  const formModal = document.getElementById('tradeFormModal');
  const openFormBtn = document.getElementById('openTradeForm');
  const form = document.getElementById('tradeForm');
  const tradeIdInput = document.getElementById('tradeId');
  const titleInput = document.getElementById('tradeTitle');
  const intentInput = document.getElementById('tradeIntent');
  const categoryInput = document.getElementById('tradeCategory');
  const regionInput = document.getElementById('tradeRegion');
  const exTypeInput = document.getElementById('tradeExchangeType');
  const descInput = document.getElementById('tradeDescription');
  const contactInput = document.getElementById('tradeContact');
  const imageInput = document.getElementById('tradeImage');
  const imagePreview = document.getElementById('tradeImagePreview');
  const formStatus = document.getElementById('tradeFormStatus');
  const formTitle = document.getElementById('tradeFormTitle');
  const formSubmitBtn = document.getElementById('tradeFormSubmit');

  // Detail modal
  const detailModal = document.getElementById('tradeDetailModal');
  const detailTitle = document.getElementById('tradeDetailTitle');
  const detailCategory = document.getElementById('tradeDetailCategory');
  const detailRegion = document.getElementById('tradeDetailRegion');
  const detailIntent = document.getElementById('tradeDetailIntent');
  const detailExchange = document.getElementById('tradeDetailExchange');
  const detailAuthor = document.getElementById('tradeDetailAuthor');
  const detailAuthorBadge = document.getElementById('detailAuthorBadge');
  const detailDescription = document.getElementById('tradeDetailDescription');
  const detailContact = document.getElementById('tradeDetailContact');
  const detailTimestamp = document.getElementById('tradeDetailTimestamp');
  const detailActions = document.getElementById('tradeDetailActions');
  const detailGallery = document.getElementById('tradeDetailGallery');

  // Public profile modal
  const profileModal = document.getElementById('profilePreviewModal');
  const profileNameEl = document.getElementById('profilePreviewName');
  const profileTitleEl = document.getElementById('profilePreviewTitle');
  const profileOccupationEl = document.getElementById('profilePreviewOccupation');
  const profileRegionEl = document.getElementById('profilePreviewRegion');
  const profileBioEl = document.getElementById('profilePreviewBio');
  const profileContactEl = document.getElementById('profilePreviewContact');
  const profileStatusEl = document.getElementById('profilePreviewStatus');
  const profileAvatarEl = document.getElementById('profilePreviewAvatar');
  const profileMessageBtn = document.getElementById('profileMessageBtn');

  const detailAuthorAvatar = document.getElementById('detailAuthorAvatar');
  const messageAuthorBtn = document.getElementById('messageAuthorBtn');

  const viewChatsBtn = document.getElementById('viewChatsBtn');

  const chatOverlay = document.getElementById('chatOverlay');
  const chatTitleEl = document.getElementById('chatTitle');
  const chatMessagesEl = document.getElementById('chatMessages');
  const chatInput = document.getElementById('chatInput');
  const chatForm = document.getElementById('chatForm');
  const chatStatus = document.getElementById('chatStatus');
  const chatClose = document.getElementById('chatClose');
  const chatThreadList = document.getElementById('chatThreadList');
  const chatImage = document.getElementById('chatImage');
  const blockUserBtn = document.getElementById('blockUserBtn');
  const deleteChatBtn = document.getElementById('deleteChatBtn');
  const tradeSuccessModal = document.getElementById('tradeSuccessModal');
  const tradeSuccessYes = document.getElementById('tradeSuccessYes');
  const tradeSuccessNo = document.getElementById('tradeSuccessNo');
  const tradeSuccessStatus = document.getElementById('tradeSuccessStatus');
  const tradeSuccessTitle = tradeSuccessModal?.querySelector('h2, h3');
  if (tradeSuccessTitle) tradeSuccessTitle.textContent = 'Did you complete this trade?';
  if (tradeSuccessYes) tradeSuccessYes.textContent = 'Yes';
  if (tradeSuccessNo) tradeSuccessNo.textContent = 'Not yet';

  let allTrades = [];
  let renderLimit = 12;
  const renderStep = 12;
  let isLoadingMore = false;
  let currentEditId = null;
  let currentImagePaths = [];
  const profileCache = new Map();
  let currentUser = null;
  let chatTargetId = null;
  let blockedUsers = new Set();
  let tradePromptedThisChat = false;
  let activeChatMessageCount = 0;
  let activeReceivedMessageCount = 0;
  let activeTradeSuccessState = null;
  let tradePromptPendingAfterDelete = false;
  const TRADE_CHAT_ORIGINS_KEY = 'lnf_trade_chat_origins';

  const getTradeChatOrigins = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(TRADE_CHAT_ORIGINS_KEY) || '{}');
      return (parsed && typeof parsed === 'object') ? parsed : {};
    } catch (_) {
      return {};
    }
  };

  const setTradeChatOrigin = (userId, tradeId = null) => {
    const key = String(userId || '').trim();
    if (!key) return;
    const map = getTradeChatOrigins();
    map[key] = {
      user_id: key,
      trade_id: tradeId || null,
      started_at: new Date().toISOString()
    };
    localStorage.setItem(TRADE_CHAT_ORIGINS_KEY, JSON.stringify(map));
  };

  const hasTradeChatOrigin = (userId) => {
    const key = String(userId || '').trim();
    if (!key) return false;
    const map = getTradeChatOrigins();
    return Boolean(map[key]);
  };
  let intentFilter = '';
  const MAX_LISTING_IMAGES = 8;

  const intentButtons = Array.from(document.querySelectorAll('[data-trade-intent]'));

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const escapeAttr = (value) => escapeHtml(value).replace(/`/g, '&#96;');

  const sanitizeMediaSrc = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    if (/^data:(image|video)\/[a-z0-9.+-]+;base64,/i.test(raw)) return raw;
    if (/^blob:/i.test(raw)) return raw;
    try {
      const parsed = new URL(raw, window.location.origin);
      if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.toString();
      if (parsed.protocol === 'blob:' || parsed.protocol === 'data:') return raw;
    } catch (_err) {
      // ignore invalid URL values
    }
    return '';
  };

  const setSignInPrompt = (el, label) => {
    if (!el) return;
    el.textContent = `Please sign in to submit a ${label}. `;
    const signInLink = document.createElement('a');
    signInLink.href = 'profile.html';
    signInLink.textContent = 'Sign in';
    el.appendChild(signInLink);
    window.lnfAuthGate?.show?.();
  };

  const normalizeIntent = (value) => {
    const raw = (value || '').toLowerCase();
    if (!raw) return '';
    if (raw.startsWith('lost') || raw.includes('looking')) return 'lost';
    if (raw.startsWith('found') || raw.includes('offer')) return 'found';
    return raw;
  };

  const intentLabel = (intent) => (intent === 'lost' ? 'Looking for' : 'Offering');

  const updateIntentButtons = () => {
    const active = normalizeIntent(intentFilter);
    intentButtons.forEach((btn) => {
      const btnIntent = normalizeIntent(btn.dataset.tradeIntent);
      if (btnIntent && btnIntent === active) {
        btn.classList.add('is-active');
        btn.classList.remove('is-inactive');
      } else {
        btn.classList.remove('is-active');
        btn.classList.add('is-inactive');
      }
    });
  };

  // hydrate filters from URL params
  const urlParams = new URLSearchParams(window.location.search);
  const focusMode = urlParams.get('focus') === '1';
  const directTradeId = (urlParams.get('trade_id') || '').trim();
  const searchTermRaw = (urlParams.get('q') || '').trim();
  const searchTerm = searchTermRaw.toLowerCase();
  if (filterCategory) filterCategory.value = urlParams.get('category') || '';
  if (filterRegion) filterRegion.value = urlParams.get('region') || '';
  intentFilter = normalizeIntent(urlParams.get('intent')) || (searchTermRaw ? '' : 'found');

  updateIntentButtons();

  const getMyTradeIds = () => {
    try {
      return JSON.parse(localStorage.getItem('lnf_my_trade_ids') || '[]');
    } catch (e) {
      return [];
    }
  };

  const rememberTradeId = (id) => {
    if (!id) return;
    const set = new Set(getMyTradeIds().map(String));
    set.add(String(id));
    localStorage.setItem('lnf_my_trade_ids', JSON.stringify(Array.from(set)));
  };

  const buildTradeFeedCommentPayload = (trade = {}, fallbackPayload = {}) => {
    const intent = normalizeIntent(trade.listing_intent || fallbackPayload.listing_intent || 'found') || 'found';
    const title = String(trade.title || fallbackPayload.title || 'Trade listing').trim();
    const description = String(trade.description || fallbackPayload.description || '').trim();
    const contact = String(trade.contact || fallbackPayload.contact || '').trim();
    const details = [description, contact].filter(Boolean).join('\n\n');
    return {
      topic: title,
      body: details || null,
      post_type: 'trade_listing',
      trade_id: trade.id || null,
      trade_intent: intent,
      trade_status: 'open'
    };
  };

  const postTradeToCommentsFeed = async (trade = {}, fallbackPayload = {}) => {
    const commentPayload = buildTradeFeedCommentPayload(trade, fallbackPayload);
    await jsonFetch('/api/comments', {
      method: 'POST',
      body: JSON.stringify(commentPayload)
    });
  };

  const isOwner = (trade) => {
    const OWNER_USERNAME = 'lostnfound';
    const token = localStorage.getItem('lnf_token');
    if (!token || !currentUser) return false;
    if (currentUser.can_manage_all_trades === true) return true;
    const currentUserId = currentUser.id;
    const currentUsername = (currentUser && currentUser.username ? currentUser.username : '').toLowerCase();
    const creatorUserId = trade.creator_id || null;

    // Original LostNFound owner account can manage any listing.
    if (currentUsername === OWNER_USERNAME) return true;
    // All other users can only manage their own listings.
    if (currentUserId && creatorUserId && String(creatorUserId) === String(currentUserId)) return true;
    return false;
  };

  const formatDate = (value) => {
    if (!value) return '';
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? '' : d.toLocaleString();
  };

  const initialFor = (name) => {
    const first = (name || '').trim().charAt(0);
    return first ? first.toUpperCase() : 'U';
  };

  const renderAvatarEl = (el, src, name = '') => {
    if (!el) return;
    el.textContent = '';
    const safeSrc = sanitizeMediaSrc(src);
    if (safeSrc) {
      const image = document.createElement('img');
      image.src = safeSrc;
      image.alt = name ? `${String(name).trim()} profile` : 'Profile photo';
      el.appendChild(image);
      return;
    }
    const fallback = document.createElement('span');
    fallback.className = 'avatar-fallback';
    fallback.textContent = initialFor(name);
    el.appendChild(fallback);
  };

  const avatarMarkup = (src, name = '', extraClass = '') => {
    const safeClass = String(extraClass || '').replace(/[^a-zA-Z0-9_\-\s]/g, '').trim();
    const className = `avatar${safeClass ? ` ${safeClass}` : ''}`;
    const safeSrc = sanitizeMediaSrc(src);
    if (safeSrc) {
      return `<div class="${className}"><img src="${escapeAttr(safeSrc)}" alt="${escapeAttr(name || 'Profile photo')}"></div>`;
    }
    return `<div class="${className}"><span class="avatar-fallback">${escapeHtml(initialFor(name))}</span></div>`;
  };

  const resolveTradeBadge = (count, isAdmin, isNodeConnected) => {
    if (isAdmin || isNodeConnected || count >= 101) return 'Established Node';
    if (count >= 51) return 'Tree (51-100 trades)';
    if (count >= 21) return 'Producer (21-50 trades)';
    if (count >= 6) return 'Sprout (6-20 trades)';
    return 'Seedling (beginner)';
  };

  const getTradeBadgeData = (trade = {}) => {
    const count = Number(trade.creator_trade_success_count ?? trade.trade_success_count ?? 0);
    const isAdmin = Boolean(trade.creator_is_admin || trade.is_admin);
    const isNodeConnected = Boolean(trade.creator_node_connected || trade.is_node_connected);
    return {
      count,
      label: resolveTradeBadge(count, isAdmin, isNodeConnected)
    };
  };

  const badgeMarkup = (label) => (label ? `<span class="trade-badge">${escapeHtml(label)}</span>` : '');

  const loadCurrentUser = async () => {
    try {
      const me = await jsonFetch('/api/auth/me');
      currentUser = me;
      if (me && me.id) {
        localStorage.setItem('lnf_user_id', me.id);
        await loadBlocks();
      }
    } catch (err) {
      currentUser = null;
    }
  };

  const loadBlocks = async () => {
    if (!currentUser) return;
    try {
      const rows = await jsonFetch('/api/blocks');
      blockedUsers = new Set((rows || []).map((b) => String(b.blocked_id)));
    } catch (err) {
      console.warn('Could not load block list', err);
      blockedUsers = new Set();
    }
  };

  const closeModal = (modal) => modal && modal.classList.add('is-hidden');
  const openModal = (modal) => modal && modal.classList.remove('is-hidden');

  const debounce = (fn, wait = 200) => {
    let t;
    return (...args) => {
      window.clearTimeout(t);
      t = window.setTimeout(() => fn(...args), wait);
    };
  };

  const normalizeImageArray = (rawValue) => {
    if (Array.isArray(rawValue)) {
      return rawValue.filter((v) => typeof v === 'string').map((v) => v.trim()).filter(Boolean);
    }
    if (typeof rawValue === 'string') {
      const trimmed = rawValue.trim();
      if (!trimmed) return [];
      if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return parsed.filter((v) => typeof v === 'string').map((v) => v.trim()).filter(Boolean);
          }
        } catch (_) {
          return [];
        }
      }
    }
    return [];
  };

  const getTradeImages = (trade) => {
    return normalizeImageArray(trade?.image_urls);
  };

  const estimateDataUrlSize = (dataUrl) => {
    const base64 = (dataUrl && dataUrl.split(',')[1]) || '';
    return Math.ceil((base64.length * 3) / 4);
  };

  const compressImageFile = (file, { maxEdge = 1000, quality = 0.78, minQuality = 0.35, step = 0.12, targetBytes = 900 * 1024 } = {}) => {
    if (!file) return Promise.resolve({ dataUrl: null, size: 0, isWithinLimit: true });
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();
      reader.onload = (e) => {
        img.onload = () => {
          let { width, height } = img;
          const scale = Math.min(1, maxEdge / Math.max(width, height));
          if (scale < 1) {
            width = Math.round(width * scale);
            height = Math.round(height * scale);
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          let q = quality;
          let bestDataUrl = null;
          let bestSize = Infinity;
          let within = false;
          while (q >= minQuality) {
            const dataUrl = canvas.toDataURL('image/jpeg', q);
            const size = estimateDataUrlSize(dataUrl);
            if (size < bestSize) {
              bestSize = size;
              bestDataUrl = dataUrl;
              within = size <= targetBytes;
            }
            if (size <= targetBytes) break;
            q = +(q - step).toFixed(2);
          }
          resolve({ dataUrl: bestDataUrl, size: bestSize, isWithinLimit: within });
        };
        img.onerror = reject;
        img.src = e.target.result;
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const renderImagePreview = (srcList = []) => {
    if (!imagePreview) return;
    imagePreview.textContent = '';
    if (!Array.isArray(srcList) || !srcList.length) {
      return;
    }
    srcList.forEach((src, index) => {
      const safeSrc = sanitizeMediaSrc(src);
      if (!safeSrc) return;
      const image = document.createElement('img');
      image.src = safeSrc;
      image.alt = `Listing image preview ${index + 1}`;
      image.className = 'upload-preview__img';
      imagePreview.appendChild(image);
    });
  };

  const getImagePayload = async () => {
    const files = Array.from(imageInput?.files || []).slice(0, MAX_LISTING_IMAGES);
    if (files.length) {
      const images = [];
      for (const file of files) {
        const { dataUrl, size, isWithinLimit } = await compressImageFile(file);
        if (!dataUrl || !isWithinLimit) {
          const kb = Math.round((size || 0) / 1024);
          throw new Error(`Image too large after compression (~${kb}KB). Please choose a smaller photo.`);
        }
        images.push(dataUrl);
      }
      return {
        image_urls: images
      };
    }
    return {
      image_urls: currentImagePaths.length ? currentImagePaths : null
    };
  };

  const renderDetailGallery = (images = [], title = 'Listing photo') => {
    if (!detailGallery) return;
    if (!images.length) {
      detailGallery.classList.add('is-hidden');
      detailGallery.textContent = '';
      return;
    }
    detailGallery.classList.remove('is-hidden');
    detailGallery.textContent = '';
    images.forEach((src, index) => {
      const safeSrc = sanitizeMediaSrc(src);
      if (!safeSrc) return;
      const figure = document.createElement('figure');
      figure.className = 'detail-gallery__item';
      const image = document.createElement('img');
      image.src = safeSrc;
      image.alt = `${title} ${index + 1}`;
      image.className = 'detail-image';
      figure.appendChild(image);
      detailGallery.appendChild(figure);
    });
  };

  const fetchPublicProfile = async (userId) => {
    if (!userId) throw new Error('Missing user id');
    const key = String(userId);
    if (profileCache.has(key)) return profileCache.get(key);
    const profile = await jsonFetch(`/api/public-profiles/${encodeURIComponent(key)}`);
    profileCache.set(key, profile);
    return profile;
  };

  const clearProfilePreview = (fallbackName = 'Community member') => {
    if (profileNameEl) profileNameEl.textContent = fallbackName;
    if (profileTitleEl) profileTitleEl.textContent = fallbackName;
    if (profileOccupationEl) profileOccupationEl.textContent = '—';
    if (profileRegionEl) profileRegionEl.textContent = '—';
    if (profileBioEl) profileBioEl.textContent = 'No bio provided.';
    if (profileContactEl) profileContactEl.textContent = 'No contact preference shared.';
    if (profileStatusEl) profileStatusEl.textContent = '';
    renderAvatarEl(profileAvatarEl, null, fallbackName);
    if (profileMessageBtn) {
      profileMessageBtn.dataset.userId = '';
      profileMessageBtn.dataset.avatar = '';
      profileMessageBtn.classList.add('is-hidden');
    }
  };

  const openProfilePreview = async (userId, fallbackName = 'Community member') => {
    if (!profileModal || !userId) return;
    clearProfilePreview(fallbackName);
    if (profileStatusEl) profileStatusEl.textContent = 'Loading profile...';
    openModal(profileModal);
    try {
      const profile = await fetchPublicProfile(userId);
      const name = profile.display_name || fallbackName;
      if (profileNameEl) profileNameEl.textContent = name;
      if (profileTitleEl) profileTitleEl.textContent = name || 'Public Profile';
      if (profileOccupationEl) profileOccupationEl.textContent = profile.occupation || '—';
      if (profileRegionEl) profileRegionEl.textContent = profile.region || '—';
      if (profileBioEl) profileBioEl.textContent = profile.bio || 'No bio provided.';
      const contact = profile.contact_pref && profile.contact_value
        ? `${profile.contact_pref}: ${profile.contact_value}`
        : (profile.contact_pref || profile.contact_value || 'No contact preference shared.');
      if (profileContactEl) profileContactEl.textContent = contact;
      renderAvatarEl(profileAvatarEl, profile.avatar_url || null, name);
      if (profileMessageBtn) {
        const currentId = (currentUser && currentUser.id) || localStorage.getItem('lnf_user_id');
        const isSelf = currentId && String(currentId) === String(profile.user_id);
        if (profile.user_id && !isSelf) {
          profileMessageBtn.dataset.userId = String(profile.user_id);
          profileMessageBtn.dataset.avatar = profile.avatar_url || '';
          profileMessageBtn.dataset.name = name || '';
          profileMessageBtn.classList.remove('is-hidden');
        } else {
          profileMessageBtn.classList.add('is-hidden');
        }
      }
      if (profileStatusEl) profileStatusEl.textContent = '';
    } catch (err) {
      console.error('public profile load error:', err);
      if (profileStatusEl) profileStatusEl.textContent = 'Could not load profile.';
    }
  };

  const ensureSignedInForChat = async () => {
    if (currentUser) return true;
    await loadCurrentUser();
    if (currentUser) return true;
    window.lnfAuthGate?.show?.();
    if (chatStatus) chatStatus.textContent = 'Sign in required.';
    return false;
  };

  const isTargetBlocked = () => chatTargetId && blockedUsers.has(String(chatTargetId));

  const updateChatControls = () => {
    if (blockUserBtn) {
      if (!chatTargetId) {
        blockUserBtn.disabled = true;
        blockUserBtn.textContent = 'Block';
      } else {
        blockUserBtn.disabled = false;
        blockUserBtn.textContent = isTargetBlocked() ? 'Unblock' : 'Block';
      }
    }
    if (deleteChatBtn) deleteChatBtn.disabled = !chatTargetId;
  };

  const normalizeTradeConfirmState = (value) => {
    const raw = String(value || '').trim().toLowerCase();
    if (raw === 'success') return 'success';
    if (raw === 'not_now') return 'not_now';
    return null;
  };

  const getTradeConfirmationMessage = (tradeState = null) => {
    const myState = normalizeTradeConfirmState(tradeState?.my_state);
    const otherState = normalizeTradeConfirmState(tradeState?.other_state);
    if (myState === 'success' && otherState === 'success') {
      return 'Trade confirmed by both sides.';
    }
    if (myState === 'success' && otherState !== 'success') {
      return 'You marked this trade complete. Waiting on the other person.';
    }
    if (otherState === 'success' && myState !== 'success') {
      return 'They marked this trade complete. Use the check if it worked.';
    }
    if (myState === 'not_now' && otherState === 'not_now') {
      return 'Both sides marked this trade as not complete yet.';
    }
    if (myState === 'not_now') {
      return 'You marked this trade as not complete yet.';
    }
    if (otherState === 'not_now') {
      return 'They marked this trade as not complete yet.';
    }
    return 'Check back in here when the trade is complete.';
  };

  const renderTradeConfirmationInline = () => {
    if (!chatMessagesEl || !activeTradeSuccessState?.show_inline_box) return;
    const row = document.createElement('div');
    row.className = 'chat-message chat-message--trade-confirm';
    const card = document.createElement('div');
    card.className = 'trade-confirm-inline';

    const title = document.createElement('p');
    title.className = 'trade-confirm-inline__title';
    title.textContent = 'Trade check-in';
    card.appendChild(title);

    const body = document.createElement('p');
    body.className = 'trade-confirm-inline__body';
    body.textContent = getTradeConfirmationMessage(activeTradeSuccessState);
    card.appendChild(body);

    const actions = document.createElement('div');
    actions.className = 'trade-confirm-inline__actions';

    const yesBtn = document.createElement('button');
    yesBtn.type = 'button';
    yesBtn.className = 'button tiny';
    yesBtn.textContent = '✓';
    yesBtn.setAttribute('aria-label', 'Confirm trade complete');
    yesBtn.addEventListener('click', () => submitTradeSuccess(true, { source: 'inline' }));
    actions.appendChild(yesBtn);

    const noBtn = document.createElement('button');
    noBtn.type = 'button';
    noBtn.className = 'button ghost tiny';
    noBtn.textContent = 'X';
    noBtn.setAttribute('aria-label', 'Keep trade open');
    noBtn.addEventListener('click', () => submitTradeSuccess(false, { source: 'inline' }));
    actions.appendChild(noBtn);

    card.appendChild(actions);
    row.appendChild(card);
    chatMessagesEl.appendChild(row);
  };

  const loadTradeSuccessState = async () => {
    if (!chatTargetId || !currentUser) {
      activeTradeSuccessState = null;
      return null;
    }
    const status = await jsonFetch(`/api/trade-success/${encodeURIComponent(String(chatTargetId))}/status`);
    activeTradeSuccessState = status || null;
    return activeTradeSuccessState;
  };

  const resetTradePrompt = () => {
    tradePromptedThisChat = false;
    activeChatMessageCount = 0;
    activeReceivedMessageCount = 0;
    activeTradeSuccessState = null;
    tradePromptPendingAfterDelete = false;
    if (tradeSuccessStatus) tradeSuccessStatus.textContent = '';
  };

  const maybePromptTradeSuccess = () => {
    if (!tradeSuccessModal || tradePromptedThisChat || !chatTargetId) return;
    if (!tradePromptPendingAfterDelete && !hasTradeChatOrigin(chatTargetId)) return;
    if (!activeTradeSuccessState?.should_prompt_popup) return;
    tradePromptedThisChat = true;
    if (tradeSuccessStatus) tradeSuccessStatus.textContent = '';
    openModal(tradeSuccessModal);
  };

  const submitTradeSuccess = async (success, { source = 'modal' } = {}) => {
    if (!chatTargetId) return;
    const ok = await ensureSignedInForChat();
    if (!ok) return;
    const statusTarget = source === 'inline' ? chatStatus : tradeSuccessStatus;
    if (statusTarget) statusTarget.textContent = 'Saving your response...';
    try {
      const result = await jsonFetch('/api/trade-success', {
        method: 'POST',
        body: JSON.stringify({ other_user_id: chatTargetId, success })
      });
      await loadChatMessages();
      if (success && result?.matched) {
        if (statusTarget) statusTarget.textContent = 'Trade marked complete. Your badge will update.';
        await loadTrades();
      } else if (success) {
        if (statusTarget) statusTarget.textContent = 'Thanks! Waiting on the other person to confirm.';
      } else {
        if (statusTarget) statusTarget.textContent = 'Got it. The trade will stay open in this chat.';
      }
      tradePromptPendingAfterDelete = false;
      if (source === 'modal') {
        window.setTimeout(() => closeModal(tradeSuccessModal), 900);
      }
    } catch (err) {
      console.error('trade success error:', err);
      if (statusTarget) statusTarget.textContent = err.message || 'Could not save your response.';
    }
  };

  const renderChatMessages = (messages = []) => {
    activeChatMessageCount = Array.isArray(messages) ? messages.length : 0;
    activeReceivedMessageCount = Array.isArray(messages)
      ? messages.filter((m) => !Boolean(m?.is_mine)).length
      : 0;
    if (!chatMessagesEl) return;
    chatMessagesEl.innerHTML = '';
    messages.forEach((m) => {
      const row = document.createElement('div');
      row.className = `chat-message ${m.is_mine ? 'is-mine' : 'is-theirs'}`;
      const bubble = document.createElement('div');
      bubble.className = 'chat-bubble';
      if (m.body) {
        const text = document.createElement('p');
        text.textContent = m.body;
        bubble.appendChild(text);
      }
      if (m.image_url) {
        const safeImageSrc = sanitizeMediaSrc(m.image_url);
        if (safeImageSrc) {
          const img = document.createElement('img');
          img.src = safeImageSrc;
          img.alt = 'Attached photo';
          img.loading = 'lazy';
          bubble.appendChild(img);
        }
      }
      row.appendChild(bubble);
      const time = document.createElement('span');
      time.className = 'chat-time';
      time.textContent = formatDate(m.created_at) || '';
      row.appendChild(time);
      chatMessagesEl.appendChild(row);
    });
    renderTradeConfirmationInline();
    chatMessagesEl.scrollTop = chatMessagesEl.scrollHeight;
  };

  const renderThreadList = (threads = []) => {
    if (!chatThreadList) return;
    chatThreadList.innerHTML = '';
    if (!threads.length) {
      chatThreadList.innerHTML = '<p class="muted small">No conversations yet.</p>';
      return;
    }
    threads.forEach((t) => {
      const displayName = String(t.display_name || 'Community member').trim() || 'Community member';
      const previewText = String(t.last_message || '').trim();
      const safeAvatar = sanitizeMediaSrc(t.avatar_url || '');
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'chat-thread';
      item.dataset.userId = t.user_id;
      item.dataset.name = displayName;
      item.dataset.avatar = safeAvatar;
      item.innerHTML = `
        ${avatarMarkup(safeAvatar || null, displayName)}
        <div class="chat-thread__body">
          <p class="chat-thread__name">${escapeHtml(displayName)}</p>
          <p class="chat-thread__preview">${escapeHtml(previewText)}</p>
          <span class="chat-thread__time">${escapeHtml(formatDate(t.last_timestamp) || '')}</span>
        </div>
      `;
      item.addEventListener('click', () => {
        openChatWithUser(t.user_id, displayName, safeAvatar);
      });
      chatThreadList.appendChild(item);
    });
  };

  const loadChatThreads = async () => {
    try {
      const threads = await jsonFetch('/api/messages');
      renderThreadList(Array.isArray(threads) ? threads : []);
    } catch (err) {
      console.error('load threads error:', err);
      if (chatThreadList) chatThreadList.innerHTML = '<p class="muted small">Could not load conversations.</p>';
    }
  };

  const loadChatMessages = async () => {
    if (!chatTargetId) return;
    if (isTargetBlocked()) {
      activeTradeSuccessState = null;
      renderChatMessages([]);
      if (chatStatus) chatStatus.textContent = 'You blocked this user. Unblock to view or send messages.';
      return;
    }
    try {
      const [msgs] = await Promise.all([
        jsonFetch(`/api/messages/${encodeURIComponent(String(chatTargetId))}`),
        loadTradeSuccessState()
      ]);
      activeChatMessageCount = Array.isArray(msgs) ? msgs.length : 0;
      activeReceivedMessageCount = Array.isArray(msgs)
        ? msgs.filter((m) => !Boolean(m?.is_mine)).length
        : 0;
      renderChatMessages(msgs);
      if (chatStatus) chatStatus.textContent = msgs.length ? '' : 'No messages yet. Say hello!';
      maybePromptTradeSuccess();
    } catch (err) {
      console.error('chat load error:', err);
      activeTradeSuccessState = null;
      if (chatStatus) chatStatus.textContent = err.message || 'Could not load messages.';
      if (err.message && err.message.toLowerCase().includes('blocked')) {
        if (chatStatus) chatStatus.textContent = 'Messaging is blocked with this user.';
      }
    }
  };

  const openChatWithUser = async (userId, name = 'Community member', avatar = '') => {
    if (!userId) return;
    const ok = await ensureSignedInForChat();
    if (!ok) return;
    await loadBlocks();
    chatTargetId = userId;
    resetTradePrompt();
    if (chatTitleEl) chatTitleEl.textContent = `Chat with ${name}`;
    if (chatStatus) chatStatus.textContent = 'Loading conversation...';
    openModal(chatOverlay);
    await loadChatThreads();
    await loadChatMessages();
    updateChatControls();
    if (chatInput) chatInput.focus();
  };

  const closeChat = () => {
    chatTargetId = null;
    if (chatMessagesEl) chatMessagesEl.innerHTML = '';
    if (chatStatus) chatStatus.textContent = '';
    if (chatInput) chatInput.value = '';
    if (chatImage) chatImage.value = '';
    closeModal(chatOverlay);
    closeModal(tradeSuccessModal);
    resetTradePrompt();
    updateChatControls();
  };

  const applyFilters = () => {
    const term = searchTerm;
    const catFilter = (filterCategory && filterCategory.value || '').trim().toLowerCase();
    const regFilter = (filterRegion && filterRegion.value || '').trim().toLowerCase();
    const intent = normalizeIntent(intentFilter);
    const url = new URL(window.location.href);
    if (searchTermRaw) url.searchParams.set('q', searchTermRaw); else url.searchParams.delete('q');
    if (focusMode && searchTermRaw) url.searchParams.set('focus', '1'); else url.searchParams.delete('focus');
    if (catFilter) url.searchParams.set('category', catFilter); else url.searchParams.delete('category');
    if (regFilter) url.searchParams.set('region', regFilter); else url.searchParams.delete('region');
    if (intent) url.searchParams.set('intent', intent); else url.searchParams.delete('intent');
    window.history.replaceState({}, '', url.toString());
    return allTrades.filter((t) => {
      const title = (t.title || '').toLowerCase();
      const matchTerm = !term || title.includes(term);
      const matchCat = !catFilter || (t.category && t.category.toLowerCase().includes(catFilter));
      const matchReg = !regFilter || (t.region && t.region.toLowerCase().includes(regFilter));
      const tradeIntent = normalizeIntent(t.listing_intent) || 'found';
      const matchIntent = !intent || tradeIntent === intent;
      return matchTerm && matchCat && matchReg && matchIntent;
    });
  };

  const renderTrades = (resetLimit = false) => {
    if (!listEl) return;
    if (resetLimit) renderLimit = renderStep;

    const filtered = applyFilters();
    const visible = filtered.slice(0, renderLimit);

    listEl.innerHTML = '';

    if (!filtered.length) {
      if (listStatus) listStatus.textContent = 'No listings match that search.';
      if (loadMoreBtn) loadMoreBtn.classList.add('is-hidden');
      return;
    }

    const frag = document.createDocumentFragment();
    visible.forEach((t) => {
      const card = document.createElement('article');
      card.className = 'trade-card';
      card.dataset.id = t.id;
      card.tabIndex = 0;
      card.setAttribute('role', 'button');

      const author = t.creator_name || t.display_name || t.username || 'Community member';
      const authorId = t.creator_id || null;
      const authorAvatar = t.creator_avatar || null;
      const tradeIntent = normalizeIntent(t.listing_intent) || 'found';
      const images = getTradeImages(t);
      const img = images[0] || authorAvatar || '';
      const safeCardImage = sanitizeMediaSrc(img);
      const safeAuthorAvatar = sanitizeMediaSrc(authorAvatar || '');
      const authorName = String(author || 'Community member').trim() || 'Community member';
      const title = String(t.title || '').trim() || 'Untitled listing';
      const region = String(t.region || 'No region').trim() || 'No region';
      const category = String(t.category || 'No category').trim() || 'No category';
      const badgeData = getTradeBadgeData(t);

      card.dataset.userId = authorId ? String(authorId) : '';
      card.dataset.authorName = authorName;
      card.dataset.authorAvatar = safeAuthorAvatar;

      card.innerHTML = `
        ${safeCardImage ? `<div class="card-media"><img src="${escapeAttr(safeCardImage)}" alt="${escapeAttr(title)}"></div>` : ''}
        <div class="card-body">
          <h3 class="card-title">${escapeHtml(title)}</h3>
          <div class="card-meta-row">
            <span class="card-meta">${escapeHtml(region)}</span>
          </div>
          <div class="card-tag-row">
            <span class="pill pill-intent ${tradeIntent === 'lost' ? 'pill-lost' : 'pill-found'}">${escapeHtml(intentLabel(tradeIntent))}</span>
            <span class="card-tag">${escapeHtml(category)}</span>
          </div>
          <div class="card-footer">
            <div class="creator-chip creator-chip--flat" role="button" tabindex="0"
                 data-user-id="${escapeAttr(authorId || '')}"
                 data-author-name="${escapeAttr(authorName)}"
                 data-avatar="${escapeAttr(safeAuthorAvatar)}">
              ${avatarMarkup(safeAuthorAvatar, authorName, 'avatar--sm')}
              <div class="creator-chip__body">
                <span class="creator-chip__name">${escapeHtml(authorName)}</span>
                ${badgeMarkup(badgeData.label)}
              </div>
            </div>
          </div>
        </div>
      `;
      frag.appendChild(card);
    });

    listEl.appendChild(frag);

    if (listStatus) {
      const more = filtered.length > visible.length ? `Showing ${visible.length} of ${filtered.length}. Scroll or tap load more.` : `Showing ${visible.length} listing(s).`;
      listStatus.textContent = more;
    }

    if (loadMoreBtn) {
      if (visible.length >= filtered.length) loadMoreBtn.classList.add('is-hidden');
      else loadMoreBtn.classList.remove('is-hidden');
    }
  };

  const resetForm = () => {
    form?.reset();
    tradeIdInput.value = '';
    formStatus.textContent = '';
    currentEditId = null;
    currentImagePaths = [];
    if (imageInput) imageInput.value = '';
    renderImagePreview([]);
    if (formTitle) formTitle.textContent = 'Create a Listing';
    if (formSubmitBtn) formSubmitBtn.textContent = 'Post Listing';
    if (intentInput) intentInput.value = 'found';
  };

  const fillForm = (trade) => {
    tradeIdInput.value = trade.id || '';
    titleInput.value = trade.title || '';
    categoryInput.value = trade.category || '';
    regionInput.value = trade.region || '';
    exTypeInput.value = trade.exchange_type || '';
    if (intentInput) intentInput.value = normalizeIntent(trade.listing_intent) || 'found';
    descInput.value = trade.description || '';
    contactInput.value = trade.contact || '';
    currentEditId = trade.id;
    currentImagePaths = getTradeImages(trade);
    if (imageInput) imageInput.value = '';
    renderImagePreview(currentImagePaths);
    if (formTitle) formTitle.textContent = 'Edit Listing';
    if (formSubmitBtn) formSubmitBtn.textContent = 'Save Changes';
  };

  const openDetail = (trade) => {
    detailTitle.textContent = trade.title || 'Listing';
    detailCategory.textContent = trade.category || 'No category';
    detailRegion.textContent = trade.region || 'Region unknown';
    detailExchange.textContent = trade.exchange_type || 'N/A';
    if (detailIntent) {
      const tradeIntent = normalizeIntent(trade.listing_intent) || 'found';
      detailIntent.textContent = intentLabel(tradeIntent);
      detailIntent.classList.toggle('pill-lost', tradeIntent === 'lost');
      detailIntent.classList.toggle('pill-found', tradeIntent !== 'lost');
    }
    const author = trade.creator_name || trade.display_name || trade.username || 'Community member';
    const authorId = trade.creator_id || null;
    const authorAvatar = trade.creator_avatar || null;
    const badgeData = getTradeBadgeData(trade);
    detailAuthor.textContent = `Posted by ${author}`;
    detailAuthor.dataset.userId = authorId ? String(authorId) : '';
    detailAuthor.dataset.authorName = author || '';
    detailAuthor.dataset.avatar = authorAvatar || '';
    if (detailAuthorBadge) detailAuthorBadge.textContent = badgeData.label;
    renderAvatarEl(detailAuthorAvatar, authorAvatar, author);
    if (authorId) {
      detailAuthor.classList.add('profile-link');
      detailAuthor.setAttribute('role', 'button');
      detailAuthor.tabIndex = 0;
      detailAuthor.title = 'View full public profile';
    } else {
      detailAuthor.classList.remove('profile-link');
      detailAuthor.removeAttribute('role');
      detailAuthor.removeAttribute('title');
      detailAuthor.tabIndex = -1;
    }
    detailDescription.textContent = trade.description || 'No description provided.';
    detailContact.textContent = trade.contact || 'No contact provided.';
    const created = trade.created_at || null;
    detailTimestamp.textContent = created ? `Posted ${formatDate(created)}` : '';
    renderDetailGallery(getTradeImages(trade), trade.title || 'Listing photo');
    if (messageAuthorBtn) {
      const currentUserId = (currentUser && currentUser.id) || localStorage.getItem('lnf_user_id');
      const isSelf = authorId && currentUserId && String(currentUserId) === String(authorId);
      if (authorId && !isSelf) {
        messageAuthorBtn.dataset.userId = String(authorId);
        messageAuthorBtn.dataset.authorName = author || '';
        messageAuthorBtn.dataset.avatar = authorAvatar || '';
        messageAuthorBtn.classList.remove('is-hidden');
      } else {
        messageAuthorBtn.classList.add('is-hidden');
      }
    }

    detailActions.innerHTML = '';
    const actionsFrag = document.createDocumentFragment();
    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'button ghost';
    closeBtn.textContent = 'Close';
    closeBtn.dataset.closeModal = 'tradeDetailModal';
    actionsFrag.appendChild(closeBtn);

    if (isOwner(trade)) {
      const editBtn = document.createElement('button');
      editBtn.type = 'button';
      editBtn.className = 'button';
      editBtn.textContent = 'Edit';
      editBtn.dataset.action = 'edit';
      editBtn.dataset.id = trade.id;

      const deleteBtn = document.createElement('button');
      deleteBtn.type = 'button';
      deleteBtn.className = 'button danger';
      deleteBtn.textContent = 'Delete';
      deleteBtn.dataset.action = 'delete';
      deleteBtn.dataset.id = trade.id;

      actionsFrag.appendChild(editBtn);
      actionsFrag.appendChild(deleteBtn);
    }
    detailActions.appendChild(actionsFrag);

    openModal(detailModal);
  };

  const upsertTradeLocal = (trade) => {
    const idx = allTrades.findIndex((t) => String(t.id) === String(trade.id));
    if (idx !== -1) {
      allTrades[idx] = trade;
    } else {
      allTrades.unshift(trade);
    }
  };

  const loadTrades = async () => {
    if (listStatus) listStatus.textContent = 'Loading listings...';
    try {
      const endpointParams = new URLSearchParams();
      if (searchTermRaw) endpointParams.set('q', searchTermRaw);
      if (focusMode && searchTermRaw) endpointParams.set('limit', '80');
      const endpoint = endpointParams.toString()
        ? `/api/trades?${endpointParams.toString()}`
        : '/api/trades';
      const items = await jsonFetch(endpoint);
      allTrades = Array.isArray(items) ? items : [];
      updateFilterOptions();
      renderTrades(true);
      if (directTradeId) openTradeById(directTradeId);
    } catch (err) {
      console.error('load trades error:', err);
      if (listStatus) listStatus.textContent = 'Failed to load listings.';
    }
  };

  // ---- Event wiring ----

  const updateFilterOptions = () => {
    if (!filterCategory && !filterRegion) return;
    const categories = new Set();
    const regions = new Set();
    allTrades.forEach((t) => {
      const cat = (t.category || '').trim();
      const reg = (t.region || '').trim();
      if (cat) categories.add(cat);
      if (reg) regions.add(reg);
    });

    if (filterCategory) {
      const current = filterCategory.value;
      const opts = [''].concat(Array.from(categories).sort((a, b) => a.localeCompare(b)));
      filterCategory.innerHTML = '';
      opts.forEach((val) => {
        const opt = document.createElement('option');
        opt.value = val;
        opt.textContent = val || 'All categories';
        filterCategory.appendChild(opt);
      });
      filterCategory.value = current || '';
    }

    if (filterRegion) {
      const current = filterRegion.value;
      const opts = [''].concat(Array.from(regions).sort((a, b) => a.localeCompare(b)));
      filterRegion.innerHTML = '';
      opts.forEach((val) => {
        const opt = document.createElement('option');
        opt.value = val;
        opt.textContent = val || 'All regions';
        filterRegion.appendChild(opt);
      });
      filterRegion.value = current || '';
    }
  };

  const debouncedRender = debounce(() => renderTrades(true), 160);
  filterCategory?.addEventListener('change', debouncedRender);
  filterRegion?.addEventListener('change', debouncedRender);

  loadMoreBtn?.addEventListener('click', () => {
    renderLimit += renderStep;
    renderTrades(false);
  });

  window.addEventListener('scroll', () => {
    if (isLoadingMore) return;
    if (!loadMoreBtn || loadMoreBtn.classList.contains('is-hidden')) return;
    const nearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 140;
    if (nearBottom) {
      isLoadingMore = true;
      renderLimit += renderStep;
      renderTrades(false);
      window.setTimeout(() => { isLoadingMore = false; }, 200);
    }
  }, { passive: true });

  const ensureChatImageData = async () => {
    const file = chatImage?.files && chatImage.files[0];
    if (!file) return null;
    const { dataUrl, size, isWithinLimit } = await compressImageFile(file, {
      maxEdge: 1200,
      targetBytes: 9 * 1024 * 1024,
      quality: 0.82,
      minQuality: 0.4,
      step: 0.08
    });
    if (!isWithinLimit || !dataUrl) {
      const mb = (size || 0) / (1024 * 1024);
      throw new Error(`Image is too large (${mb.toFixed(1)} MB). Choose a smaller photo.`);
    }
    return dataUrl;
  };

  blockUserBtn?.addEventListener('click', async () => {
    if (!chatTargetId) return;
    const ok = await ensureSignedInForChat();
    if (!ok) return;
    try {
      if (isTargetBlocked()) {
        await jsonFetch(`/api/blocks/${encodeURIComponent(String(chatTargetId))}`, { method: 'DELETE' });
        if (chatStatus) chatStatus.textContent = 'User unblocked.';
      } else {
        await jsonFetch('/api/blocks', { method: 'POST', body: JSON.stringify({ user_id: chatTargetId }) });
        if (chatStatus) chatStatus.textContent = 'User blocked. You will not receive messages.';
      }
      await loadBlocks();
      updateChatControls();
    } catch (err) {
      if (chatStatus) chatStatus.textContent = err.message || 'Could not update block status.';
    }
  });

  deleteChatBtn?.addEventListener('click', async () => {
    if (!chatTargetId) return;
    const ok = await ensureSignedInForChat();
    if (!ok) return;
    try {
      await jsonFetch(`/api/messages/${encodeURIComponent(String(chatTargetId))}`, { method: 'DELETE' });
      if (chatStatus) chatStatus.textContent = 'Conversation cleared.';
      if (chatMessagesEl) chatMessagesEl.innerHTML = '';
      await loadChatThreads();
    } catch (err) {
      if (chatStatus) chatStatus.textContent = err.message || 'Could not delete conversation.';
    }
  });

  openFormBtn?.addEventListener('click', () => {
    resetForm();
    openModal(formModal);
  });

  const prefillTitle = urlParams.get('title');
  const prefillCategory = urlParams.get('category');
  const prefillIntent = normalizeIntent(urlParams.get('intent'));
  if (prefillTitle || prefillCategory || prefillIntent) {
    resetForm();
    if (intentInput && prefillIntent) intentInput.value = prefillIntent;
    if (titleInput && prefillTitle) titleInput.value = prefillTitle;
    if (categoryInput && prefillCategory) categoryInput.value = prefillCategory;
    openModal(formModal);
  }

  imageInput?.addEventListener('change', async () => {
    const files = Array.from(imageInput.files || []).slice(0, MAX_LISTING_IMAGES);
    if (!files.length) {
      renderImagePreview(currentImagePaths);
      return;
    }
    const previewImages = [];
    try {
      for (const file of files) {
        const { dataUrl, size, isWithinLimit } = await compressImageFile(file);
        if (!isWithinLimit || !dataUrl) {
          const kb = Math.round((size || 0) / 1024);
          formStatus.textContent = `Image still too large after compression (~${kb}KB). Use a smaller photo.`;
          imageInput.value = '';
          renderImagePreview(currentImagePaths);
          return;
        }
        previewImages.push(dataUrl);
      }
      renderImagePreview(previewImages);
      formStatus.textContent = '';
    } catch (err) {
      formStatus.textContent = 'Could not process image. Use a smaller JPG/PNG.';
      imageInput.value = '';
      renderImagePreview(currentImagePaths);
    }
  });

  document.body.addEventListener('click', (evt) => {
    const closeTarget = evt.target.closest('[data-close-modal]');
    if (closeTarget) {
      const id = closeTarget.dataset.closeModal;
      const modal = document.getElementById(id);
      closeModal(modal);
    }
  });

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    formStatus.textContent = '';
    const token = localStorage.getItem('lnf_token');
    if (!token) {
      setSignInPrompt(formStatus, 'trade');
      return;
    }

    const title = (titleInput.value || '').trim();
    if (!title) {
      formStatus.textContent = 'Title is required.';
      return;
    }
    window.lnfNotifications?.maybePrompt?.({ reason: 'trade' });

    let imagePayload = {
      image_urls: currentImagePaths.length ? currentImagePaths : null
    };
    try {
      imagePayload = await getImagePayload();
    } catch (imgErr) {
      formStatus.textContent = imgErr.message || 'Image too large.';
      return;
    }

    const payload = {
      title,
      listing_intent: intentInput ? intentInput.value : 'found',
      category: categoryInput.value.trim() || null,
      region: regionInput.value.trim() || null,
      exchange_type: exTypeInput.value.trim() || null,
      description: descInput.value.trim() || null,
      contact: contactInput.value.trim() || null,
      ...imagePayload
    };

    try {
      if (currentEditId) {
        const updated = await jsonFetch(`/api/trades/${currentEditId}`, {
          method: 'PUT',
          body: JSON.stringify(payload)
        });
        upsertTradeLocal(updated);
        rememberTradeId(updated.id);
        formStatus.textContent = 'Listing updated.';
      } else {
        const created = await jsonFetch('/api/trades', {
          method: 'POST',
          body: JSON.stringify(payload)
        });
        upsertTradeLocal(created);
        rememberTradeId(created.id);
        let feedShareAttempted = true;
        let feedShared = false;
        try {
          await postTradeToCommentsFeed(created, payload);
          feedShared = true;
        } catch (shareErr) {
          console.error('trade feed share error:', shareErr);
        }
        const matchNote = Array.isArray(created.match_notifications) ? created.match_notifications[0] : null;
        const statusParts = [];
        if (matchNote?.title || matchNote?.body) {
          statusParts.push([matchNote.title, matchNote.body].filter(Boolean).join(' '));
        } else {
          statusParts.push('Listing posted.');
        }
        if (feedShared) {
          statusParts.push('Shared to comments feed.');
        } else if (feedShareAttempted) {
          statusParts.push('Listing posted, but it was not added to the comments feed.');
        }
        formStatus.textContent = statusParts.join(' ');
      }
      renderTrades(true);
      closeModal(formModal);
      resetForm();
    } catch (err) {
      console.error('trade form error:', err);
      formStatus.textContent = 'Failed to save listing.';
    }
  });

  const openTradeById = (id) => {
    if (!id) return;
    const trade = allTrades.find((t) => String(t.id) === String(id));
    if (trade) openDetail(trade);
  };

  listEl?.addEventListener('click', (evt) => {
    const chip = evt.target.closest('.creator-chip');
    if (chip) {
      evt.stopPropagation();
      const uid = chip.dataset.userId;
      if (uid) openProfilePreview(uid, chip.dataset.authorName || 'Community member');
      return;
    }
    const card = evt.target.closest('.trade-card');
    if (!card) return;
    openTradeById(card.dataset.id);
  });

  listEl?.addEventListener('keydown', (evt) => {
    if (!['Enter', ' '].includes(evt.key)) return;
    const chip = evt.target.closest('.creator-chip');
    if (chip) {
      evt.preventDefault();
      const uid = chip.dataset.userId;
      if (uid) openProfilePreview(uid, chip.dataset.authorName || 'Community member');
      return;
    }
    const card = evt.target.closest('.trade-card');
    if (!card) return;
    evt.preventDefault();
    openTradeById(card.dataset.id);
  });

  detailAuthor?.addEventListener('click', () => {
    const uid = detailAuthor.dataset.userId;
    if (!uid) return;
    openProfilePreview(uid, detailAuthor.dataset.authorName || undefined);
  });

  detailAuthor?.addEventListener('keydown', (evt) => {
    if (!['Enter', ' '].includes(evt.key)) return;
    const uid = detailAuthor.dataset.userId;
    if (!uid) return;
    evt.preventDefault();
    openProfilePreview(uid, detailAuthor.dataset.authorName || undefined);
  });

  messageAuthorBtn?.addEventListener('click', () => {
    const uid = messageAuthorBtn.dataset.userId;
    if (uid) setTradeChatOrigin(uid, null);
    if (!uid) return;
    openChatWithUser(uid, messageAuthorBtn.dataset.authorName || detailAuthor?.textContent || 'Community member', messageAuthorBtn.dataset.avatar || '');
  });

  profileMessageBtn?.addEventListener('click', () => {
    const uid = profileMessageBtn.dataset.userId;
    if (!uid) return;
    openChatWithUser(uid, profileMessageBtn.dataset.name || profileNameEl?.textContent || 'Community member', profileMessageBtn.dataset.avatar || '');
  });

  viewChatsBtn?.addEventListener('click', async () => {
    const ok = await ensureSignedInForChat();
    if (!ok) return;
    await loadBlocks();
    if (chatTitleEl) chatTitleEl.textContent = 'Your conversations';
    openModal(chatOverlay);
    await loadChatThreads();
    renderChatMessages([]);
    if (chatStatus) chatStatus.textContent = 'Select a conversation to view messages.';
    updateChatControls();
  });

  tradeSuccessYes?.addEventListener('click', () => {
    submitTradeSuccess(true);
  });

  tradeSuccessNo?.addEventListener('click', () => {
    submitTradeSuccess(false);
  });

  intentButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const next = normalizeIntent(btn.dataset.tradeIntent);
      if (!next) return;
      intentFilter = next;
      updateIntentButtons();
      renderTrades(true);
    });
  });

  detailActions?.addEventListener('click', async (evt) => {
    const actionBtn = evt.target.closest('button[data-action]');
    if (!actionBtn) return;
    const { action, id } = actionBtn.dataset;
    const trade = allTrades.find((t) => String(t.id) === String(id));
    if (!trade) return;
    const token = localStorage.getItem('lnf_token');

    // Silent guard: non-owners should not have action buttons and no error UI.
    if (!token || !currentUser || !isOwner(trade)) return;

    if (action === 'edit') {
      fillForm(trade);
      closeModal(detailModal);
      openModal(formModal);
    } else if (action === 'delete') {
      const label = trade.title || 'this listing';
      const shouldDelete = await window.lnfUi.confirm({
        title: 'Delete listing',
        message: `Delete "${label}"?`,
        confirmText: 'Delete',
        cancelText: 'Cancel'
      });
      if (!shouldDelete) return;
      try {
        await jsonFetch(`/api/trades/${encodeURIComponent(String(id))}`, { method: 'DELETE' });
        tradePromptPendingAfterDelete = true;
        maybePromptTradeSuccess();
        allTrades = allTrades.filter((t) => String(t.id) !== String(id));
        renderTrades(true);
        closeModal(detailModal);
      } catch (err) {
        console.error('delete trade error:', err);
        await window.lnfUi.alert({
          title: 'Delete failed',
          message: 'Failed to delete listing.'
        });
      }
    }
  });

  chatClose?.addEventListener('click', closeChat);
  chatOverlay?.addEventListener('click', (evt) => {
    if (evt.target === chatOverlay) closeChat();
  });

  chatForm?.addEventListener('submit', async (evt) => {
    evt.preventDefault();
    if (!chatTargetId) return;
    const ok = await ensureSignedInForChat();
    if (!ok) return;
    if (isTargetBlocked()) {
      if (chatStatus) chatStatus.textContent = 'Unblock this user to send a message.';
      return;
    }
    const body = (chatInput?.value || '').trim();
    let imageData = null;
    try {
      imageData = await ensureChatImageData();
    } catch (imgErr) {
      if (chatStatus) chatStatus.textContent = imgErr.message || 'Image too large.';
      return;
    }
    if (!body && !imageData) {
      if (chatStatus) chatStatus.textContent = 'Type a message or add a photo.';
      return;
    }
    window.lnfNotifications?.maybePrompt?.({ reason: 'trade-message' });
    try {
      await jsonFetch('/api/messages', {
        method: 'POST',
        body: JSON.stringify({ to: chatTargetId, body, image_data: imageData })
      });
      if (chatInput) chatInput.value = '';
      if (chatImage) chatImage.value = '';
      await loadChatMessages();
      updateChatControls();
      maybePromptTradeSuccess();
    } catch (err) {
      console.error('send message error:', err);
      if (chatStatus) chatStatus.textContent = err.message || 'Could not send message.';
    }
  });

  // Close modals when clicking outside dialog
  [formModal, detailModal, profileModal, chatOverlay, tradeSuccessModal].forEach((modal) => {
    modal?.addEventListener('click', (evt) => {
      if (evt.target === modal) closeModal(modal);
    });
  });

  loadCurrentUser().finally(() => {
    loadTrades();
  });
});
